import "./LabUserDetailsViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import LabUserViewComponent from "./lab-user-view/LabUserViewComponent";
import LabUserEditComponent from "./lab-user-edit/LabUserEditComponent";

interface LabUserDetailsViewEditComponentProps {
    labDetails: any
    onUpdateAdminDetails: Function;
    onModeChange: Function;
    canEdit: boolean;
}

const LabUserDetailsViewEditComponent = (props: LabUserDetailsViewEditComponentProps) => {
    const {labDetails, onUpdateAdminDetails, onModeChange, canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");

    const handleLabDetailsUpdate = useCallback((updatedUserDetailsList: any) => {
        onUpdateAdminDetails((prev: any) => {
            return {
                ...prev,
                userDetails: updatedUserDetailsList
            }
        })
    }, [onUpdateAdminDetails]);

    const handleLabDetailsEditCancel = useCallback((updatedUserDetailsList: any) => {
        onUpdateAdminDetails((prev: any) => {
            return {
                ...prev,
                userDetails: updatedUserDetailsList
            }
        })
        setMode("view");
    }, [onUpdateAdminDetails]);

    useEffect(() => {
        onModeChange(mode);
    }, [mode, onModeChange]);

    return (
        <div className={'lab-user-details-view-edit-component details-tab-data-wrapper'}>
            {
                mode === "view" && <LabUserViewComponent
                    userList={labDetails?.userDetails || []}
                    canEdit={canEdit}
                    labId={labDetails.id}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                    onUpdateComplete={handleLabDetailsUpdate}
                />
            }
            {
                mode === "edit" && <LabUserEditComponent
                    userDetailsList={labDetails?.userDetails || []}
                    labId={labDetails.id}
                    onUpdateComplete={handleLabDetailsUpdate}
                    onEditCancel={handleLabDetailsEditCancel}
                />
            }
        </div>
    );

};

export default LabUserDetailsViewEditComponent;
